<template>
  <div class="aspectWrapperContainer w-100" :style="paddingTop">
    <div class="aspectContent">
      <div class="w-100 h-100">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AspectWrapper',
  props: {
    aspectRatio: {
      type: Number, // height over width
      required: false,
      default: 1
    }
  },
  computed: {
    paddingTop() {
      return `padding-top: ${Math.round(this.aspectRatio * 100).toFixed(2)}%;`;
    }
  }
};
</script>

<style lang="scss">
.aspectWrapperContainer {
  position: relative;
  .aspectContent {
    position: absolute;
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>